import { Location } from '@angular/common';
import { Component } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { Store } from '@ngrx/store';
import { map } from 'rxjs/operators';

import { State } from '®app/ngrx';
import { BibliographicResource } from '®shared/bibliographic-resource';

import { UpdateBibliographicResourceAction } from '../resource.actions';

@Component({
  selector: 'rl-resource-edit-smart',
  templateUrl: './resource-edit-smart.component.html',
})
export class ResourceEditSmartComponent {
  readonly resource$ = this.route.data.pipe(
    map(({ bibliographicResource }) => bibliographicResource),
  );

  constructor(
    private location: Location,
    private route: ActivatedRoute,
    private store: Store<State>,
  ) {}

  back(): void {
    this.location.back();
  }

  updateBibliographicResource(bibliographicResource: BibliographicResource) {
    this.store.dispatch(
      new UpdateBibliographicResourceAction({
        bibliographicResource,
      }),
    );
  }
}
